export default __webpack_public_path__ + "static/media/football.b3a6482d.png";